/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_3_Task_Deep_Focus_120_MinInputs */

const en_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accumulate 120 Minutes of Deep Focus`)
};

const ar_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اجمع 120 دقيقة من التركيز العميق`)
};

const de_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammeln Sie 120 Minuten Deep Focus`)
};

const es_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acumula 120 minutos de concentración profunda`)
};

const fr_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accumuler 120 minutes de concentration profonde`)
};

const it_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accumula 120 minuti di Concentrazione intensiva`)
};

const ja_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ディープフォーカスで合計120分達成`)
};

const ko_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`120분 초집중 누적하기`)
};

const pt_br_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acumule 120 minutos de Foco Total`)
};

const ru_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Накопите 120 минут глубокой фокусировки`)
};

const th_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สะสมการโฟกัสเต็มที่ให้ครบ 120 นาที`)
};

const tr_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`120 Dakikalık Derin Odaklanma Biriktir`)
};

const zh_cn_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累计深度专注 120 分钟`)
};

const zh_tw_phase_3_task_deep_focus_120_min = /** @type {(inputs: Phase_3_Task_Deep_Focus_120_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累計深度專注 120 分鐘`)
};

/**
* | output |
* | --- |
* | "Accumulate 120 Minutes of Deep Focus" |
*
* @param {Phase_3_Task_Deep_Focus_120_MinInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const phase_3_task_deep_focus_120_min = /** @type {((inputs?: Phase_3_Task_Deep_Focus_120_MinInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_3_Task_Deep_Focus_120_MinInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phase_3_task_deep_focus_120_min(inputs)
	if (locale === "ar") return ar_phase_3_task_deep_focus_120_min(inputs)
	if (locale === "de") return de_phase_3_task_deep_focus_120_min(inputs)
	if (locale === "es") return es_phase_3_task_deep_focus_120_min(inputs)
	if (locale === "fr") return fr_phase_3_task_deep_focus_120_min(inputs)
	if (locale === "it") return it_phase_3_task_deep_focus_120_min(inputs)
	if (locale === "ja") return ja_phase_3_task_deep_focus_120_min(inputs)
	if (locale === "ko") return ko_phase_3_task_deep_focus_120_min(inputs)
	if (locale === "pt_br") return pt_br_phase_3_task_deep_focus_120_min(inputs)
	if (locale === "ru") return ru_phase_3_task_deep_focus_120_min(inputs)
	if (locale === "th") return th_phase_3_task_deep_focus_120_min(inputs)
	if (locale === "tr") return tr_phase_3_task_deep_focus_120_min(inputs)
	if (locale === "zh_cn") return zh_cn_phase_3_task_deep_focus_120_min(inputs)
	return zh_tw_phase_3_task_deep_focus_120_min(inputs)
});